import { Component, Input } from '@angular/core';

/**
 * Exibe um checklist visual dos requisitos de senha forte.
 * Atualiza em tempo real conforme o valor do @Input() senha muda.
 *
 * Uso:
 *   <app-senha-checklist [senha]="form.controls.novaSenha.value"></app-senha-checklist>
 */
@Component({
  selector: 'app-senha-checklist',
  templateUrl: './senha-checklist.component.html',
  styleUrls: ['./senha-checklist.component.scss']
})
export class SenhaChecklistComponent {
  @Input() senha: string = '';

  get temMinLength(): boolean {
    return this.senha.length >= 8;
  }

  get temMaiuscula(): boolean {
    return /[A-Z]/.test(this.senha);
  }

  get temNumero(): boolean {
    return /[0-9]/.test(this.senha);
  }

  get temEspecial(): boolean {
    return /[^A-Za-z0-9]/.test(this.senha);
  }
}
